import {dispatchEvent} from '@s-ui/js/lib/events'

import FetcherFactory from '../../fetcher/Fetchers/factory.js'
import factoryLogger from '../../logger/index.js'
import AdvertisingMappersFactory from '../Mappers/factory.js'
import AdvertisingValueObjectsFactory from '../ValueObjects/factory.js'
import DOMAdvertisingRepository from './DOMAdvertisingRepository.js'
import EmptyAdvertisingRepository from './EmptyAdvertisingRepository.js'
import {HTTPSaitamaRepository} from './HTTPSaitamaRepository.js'

const ENV = process.env.STAGE
const TEST_ENV = 'test'

export default class AdvertisingRepositoriesFactory {
  static hTTPAdvertisingConfigurationRepository = ({config}) =>
    new HTTPSaitamaRepository({
      config,
      fetcher: ENV !== TEST_ENV ? FetcherFactory.fakeFetcher({config}) : FetcherFactory.httpFetcher({config}),
      log: factoryLogger({prefix: 'HTTPSaitamaRepository'}),
      valueObject: AdvertisingValueObjectsFactory.saitamaConfigurationValueObject
    })

  static emptyAdvertisingRepository = ({config}) => new EmptyAdvertisingRepository({config})

  static domAdvertisingRepository = ({config}) => {
    return new DOMAdvertisingRepository({
      config,
      dispatcher: dispatchEvent,
      fromAdvertisingVOToAdvertisingPageDataVOMapper:
        AdvertisingMappersFactory.fromAdvertisingValueObjectToAdvertisingPageDataValueObjectMapper({config})
    })
  }
}
